<template>
  <div class="outstanding-header">

    <CustomModal 
    :size="'sm'"
    :open="payment_modal"
    :keepratio="true"
    @close-modal="payment_modal = false">
      <template slot="modal_content">
        <PaymentCB :type="'outstanding'" />
        <span class="btn" @click="vSubmitPayment">{{$_('pay').toUpperCase()}}</span>
      </template>
    </CustomModal>

    <div class="grid-row">
      <div class="c-12">
        <div class="outstanding-list list">
          <div class="outstanding-list-header list-header">
            <ul>
              <li>{{$_('accounting_date')}}</li>
              <li>{{$_('newspaper')}}</li>
              <li>{{$_('part_no')}}</li>
              <li>{{$_('word')}}</li>
              <li>{{$_('deadline')}}</li>
              <li>{{$_('amount_debited')}}</li>
              <li>{{$_('amount_credited')}}</li>
              <li>{{$_('currency')}}</li>
              <li>{{$_('pay')}}</li>
            </ul>
          </div>
          <div class="outstanding-list-body list-body">
            <div v-for="(item, index) in items" :key="index" ref="outstanding_list">
              <OutstandingLine :dataline="item" :index="index" @currency="differentCurrency($event, index)" ref="outstandingLine"/>
            </div>
          </div>
        </div>
        <div v-if="getOutstandingAmount > 0">
          <span @click="vPayOutstanding" class="btn">{{$_('pay_outstanding')}} ( {{getOutstandingAmount}} {{this.$store.getters['application/get_application_customer'].TCDEV}} )</span>
        </div>
        <div v-if="is_same_currency === false" class="currency-error">
          <p>{{$_('currency_error')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OutstandingLine from "@/modules/encour/components/OutstandingLine";
import CustomModal from '@/common/components/widget/Modal/CustomModal';
import PaymentCB from '@/modules/panier/components/PaymentCB';

import outstandingService from "@/modules/encour/services/outstandingService";

export default {
  name: "OutstandingList",
  components: {
    OutstandingLine,
    CustomModal,
    PaymentCB
  },
  data() {
    return {
      items: Array(),
      payment_modal: false,
      outstanding_amount: 0,
      currency: [],
      is_same_currency: true 
    };
  },
  created() {
    outstandingService
      .getOutStandingList()
      .then(res => {
        if (res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.items.push(obj);
          });
        }
      })
      .catch(err => console.error(err));
  },
  computed: {
    getOutstandingAmount() {
      return this.$store.getters['encour/get_outstanding_pay'];
    },
    getDifferentCurrency() {
      return this.different_currency;
    }
  },
  methods: {
    vPayOutstanding() {
      this.payment_modal = true
    },
    vSubmitPayment() {
      if(this.$store.getters['panier/get_payment_method'] === 'bankcard_outstanding') {
        this.$store.getters['encour/get_form_cb_outstanding_ref'].submit(); 
      }
    },
    differentCurrency() {
    
      this.currency = [];

      this.$refs.outstandingLine.map(element => {
        if(element._data.value_pay === 'O') {
          this.currency.push(element._data.lineData.tdev);
        }
      }); 

      const test = (currentValue, arrIndex, array) => arrIndex > 0 ? currentValue === array[arrIndex - 1] : true;
    
      this.is_same_currency = this.currency.every(test);
    }
  }
};
</script>

<style scoped>
.outstanding-list {
  padding: 30px 0px;
}
.outstanding-list-header ul {
  display: flex;
}
.outstanding-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 9);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.outstanding-list-header {
  padding: 15px 0px;
}
.currency-error {
  border: solid 1px red;
  display: block;
  padding:15px;
}
.currency-error p {
  color: red;
}
</style>